import { getIsFeatureToggleEnabled } from 'communicator/store/selectors';
import { TokenResponse } from 'types/api/token';
import { FetchResponse } from 'types/fetch';
import endpoints from '../endpoints';
import fetchReq from '../fetch';
import getVbaToken from '../get-vba-token';

type GenerateAccessTokenFromAuthCodeOptions = {
  apikey: string;
  authCode: string;
  sessionId: string;
};

export function generateAccessTokenFromAuthCode({
  apikey,
  authCode,
  sessionId
}: GenerateAccessTokenFromAuthCodeOptions): FetchResponse<TokenResponse> {
  return fetchReq({
    body: {
      code: authCode,
      context: JSON.stringify({
        branding: 'SRC',
        channel: 'Web',
        context: 'ENROLLMENT',
        cookieId: '',
        dfpSessionId: sessionId,
        eventSource: 'LightboxTW',
        eventSubType: 'Email',
        merchantApiKey: apikey,
        SubContext: 'CONSUMER_LIGHTBOX'
      }),
      grant_type: 'authorization_code'
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    mark: 'auth_to_access_token',
    method: 'POST',
    url: endpoints.token.auth
  });
}

type GenerateAccessTokenFromIdTokenOptions = {
  apikey: string;
  idToken: string;
  mark: string;
  sessionId: string;
};

export async function generateAccessTokenFromIdToken({
  apikey,
  idToken,
  mark,
  sessionId
}: GenerateAccessTokenFromIdTokenOptions): FetchResponse<TokenResponse> {
  let uebaId: string | null = sessionId;
  let uebaSource: string | null = 'THREAT_METRIX';

  if (getIsFeatureToggleEnabled('vbaDeviceProfile')) {
    uebaId = await getVbaToken();
    uebaSource = 'VBA';
  }

  return fetchReq({
    body: {
      assertion: idToken,
      function: 'LOGIN@FED',
      grant_type: 'urn:ietf:params:oauth:grant-type:jwt-bearer',
      'software_statement_claimset.oauth2_version': '1.0',
      'software_statement_claimset.software_id': 'SRC',
      'software_statement_claimset.software_version': '22.04.00',
      'software_statement_claimset.tenancy_context.product_code': 'VXO',
      'software_statement_claimset.uebas[0].ueba_id': uebaId,
      'software_statement_claimset.uebas[0].ueba_source': uebaSource
    },
    headers: {
      Authorization: `Basic ${window.btoa(apikey)}`,
      'Content-Type': 'application/x-www-form-urlencoded',
      Prefer: 'gw_version=1'
    },
    mark,
    method: 'POST',
    url: endpoints.token.auth
  });
}
